$(document).ready(function () {

    $(document).on('click', '.quantity button', function(){
        event.preventDefault();

        var elem   = $(this),
            parent = elem.parent(),
            input  = parent.find('input'),
            min    = input.data('min'),
            val    = Math.floor(input.val()),
            item   = elem.parents('.table-item'),
            id     = item.data('id'),
            price  = item.find('.price span').text(),
            total  = item.find('.total span');

        if(!min){
            min = 0;
        }

        if(elem.hasClass('cart-quantity-plus') && val < 50){
            val++;
            input.val( val );
            total.text(price * val);

            updateItem(id, val);
        }else if(elem.hasClass('cart-quantity-minus') && val > min){
            val--;
            input.val( val );
            total.text(price * val);

            updateItem(id, val);
        }
        
    })

    $(document).on('click', '.remove-item', function(){
        var item    = $(this).parents('.table-item');
            id      = item.attr('data-id'),
            item    = $('.table-item[data-id="' + id + '"]');

        item.remove();

        if($('.user-cart').find('.table-item').length == 0){
            $('.cart-content').slideUp(400);
            $('.empty-cart').slideDown(400);
            $('.one-click-popup-btn').attr('disabled', true);

            setTimeout(function(){
                $('.cart-content').remove();
            }, 400);
        }else{
            $('.one-click-popup-btn').removeAttr('disabled', true);
        }

        jQuery.post('/wp-admin/admin-ajax.php', {
            action: 'del_cart_product',
            id: id
        },
        function (res) {
        
            cart_widget();
            
            loader_off();

        });
        

    })

    $('.one-click-btn').click(function(){
        $('.one-click-popup').fadeIn(300);
        $('.one-click-popup .close-popup, .one-click-blackboard').click(function(){
            $('.one-click-popup').fadeOut(300);
        })
    })

    $('.open-kaspi').click(function(){
        $('.kaspi-popup').fadeIn(300);
    })

    $('.kaspi-popup .close-popup, .kaspi-blackboard').click(function(){
        $('.kaspi-popup').fadeOut(300);
    })

    $('.close-error-popup, .error-popup-blackboard').click(function(){
        $('.error-popup').fadeOut(300);
        $('.error-popup').removeClass('show');
        $('.error-code').slideUp(300);
    })

    $('.show-code').click(function(){
        $('.error-code').slideToggle(400);
    })

    $('.one-click-popup-btn').click(function(){
        event.preventDefault();
        $('.one-click-content .required').each(inputCheck);
        if($('.one-click-content .error').length == 0){
            
        }
    })

});